function WaitMessage() {
  return (
    <div className="wait-msg">
      <img src="/images/wait.svg" alt="wait icon"/>
    </div>
  )
}

export default WaitMessage
